import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  styled
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { LOCAL_STORAGE_KEYS, colours } from 'utils/constants';
import useSendFeedback from './crud/useSendFeedback';

const CustomDialogContent = styled(DialogContent)({
  paddingTop: '10px !important'
});

interface FeedbackModalProps {
  openFeedbackModal: boolean;
  handleCloseFeedbackModal: () => void;
  feedbackMessage: string;
  setFeedbackMessage: React.Dispatch<React.SetStateAction<string>>;
  feedbackUuid: string | null;
  setSnackbar: React.Dispatch<
    React.SetStateAction<{ open: boolean; message: string; isError: boolean }>
  >;
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({
  openFeedbackModal,
  handleCloseFeedbackModal,
  feedbackMessage,
  setFeedbackMessage,
  feedbackUuid,
  setSnackbar
}) => {
  const sendAdditionalFeedbackMutation = useSendFeedback({
    onSuccess: () => {
      setSnackbar({ open: true, message: 'Feedback submitted successfully!', isError: false });
      setFeedbackMessage('');
      handleCloseFeedbackModal();
    },
    onError: () => {
      setSnackbar({
        open: true,
        message: 'Failed to send additional feedback. Please try again.',
        isError: true
      });
    }
  });

  const handleFeedbackChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFeedbackMessage(event.target.value);
  };

  const handleFeedbackSubmit = () => {
    if (feedbackMessage && feedbackUuid) {
      const sessionId = localStorage.getItem(LOCAL_STORAGE_KEYS.aiChatSessionId) || '';
      sendAdditionalFeedbackMutation.mutate({
        payload: {
          is_good: false,
          session_id: sessionId,
          feedback: feedbackMessage
        },
        feedbackUuid
      });
    }
  };

  return (
    <Dialog open={openFeedbackModal} onClose={handleCloseFeedbackModal} maxWidth="sm" fullWidth>
      <DialogTitle>
        Please provide additional feedback? (optional)
        <IconButton
          onClick={handleCloseFeedbackModal}
          style={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <CustomDialogContent>
        <TextField
          label="Feedback"
          multiline
          rows={4}
          variant="outlined"
          fullWidth
          value={feedbackMessage}
          onChange={handleFeedbackChange}
        />
      </CustomDialogContent>
      <DialogActions sx={{ marginBottom: 1 }}>
        <Button
          onClick={handleFeedbackSubmit}
          variant="contained"
          size="small"
          sx={{
            textTransform: 'none',
            fontSize: '1rem',
            backgroundColor: colours.seafoam,
            color: '#fff',
            boxShadow: 'none',
            borderRadius: '8px',
            '&:hover': { backgroundColor: colours.seafoam, boxShadow: 'none' }
          }}
          disabled={!feedbackMessage}
        >
          Submit Feedback
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedbackModal;
